import { useDispatch, useSelector } from "react-redux";
import { MapIndicator } from "../index";
import { getIcons } from "_helpers";
import { useEffect } from "react";
import { eventsActions } from "_store";
import { useLocation } from "react-router-dom";
import { selectEventsAlertCount, selectEventsPreAlertCount, selectEventsStopCount } from "_store/selectors/alerts.selector";


export { AlertFilteringIndicator }

/**
 * Indicateurs de données. S'affiche sur la page Données et sur la page Alertes
 * Le tableau data regrouppe les données envoyées aux boutons indicateurs.
 * Chaque bouton dispose de ses propres données et actions
 * @returns  
 */
function AlertFilteringIndicator()  {

    const events = useSelector(state => state.events);
    const filters = useSelector(state => state.events.filters);
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    
    /* Comptage des données via les selector*/
    const stopsCount = useSelector(selectEventsStopCount);
    const alertsCount = useSelector(selectEventsAlertCount);
    const preAlertsCount = useSelector(selectEventsPreAlertCount)

    /* Méthode envoyée en callback pour gérer le clic sur les différents boutons */
    const handleFilterClick = (filter) => {
        if (filters.includes(filter)) {
            dispatch(eventsActions.removeFilter(filter));
        } else {
            dispatch(eventsActions.addFilter(filter));
        }   
    };

    /* Récupération des données en absence de celles ci dans le store */
    useEffect(() => {
        if(!events){ 
            dispatch(eventsActions.getAll());
        }
    }, [])

    /* Données envoyées aux indicateurs */
    const data = [
        {
            title: "Alertes 3",
            value: alertsCount,
            icon: getIcons("busAlertOutlinedWhite"),
            color: 'primary-orange',
            isActiveClass: 'bg-primary-orange text-global-white',
            clickable: true,
            isActive: true,
            action: () => handleFilterClick('3')
        },
        {
            title: "Stops 4",
            value: stopsCount,
            icon: getIcons("busAlertOutlinedWhite"),
            color: 'primary-red',
            isActiveClass: 'bg-primary-red text-global-white',
            clickable: true,
            isActive: true,
            action: () => handleFilterClick('4')
        }
    ]
    
    if (pathname !== '/donnees'){
        data.push({
            title: "Pré-alertes",
            value: preAlertsCount,
            icon: getIcons("busAlertOutlinedWhite"),
            color: 'primary-lightblue',
            isActiveClass: 'bg-primary-lightblue text-global-white',
            clickable: true,
            isActive: true,
            action: () => handleFilterClick('0')
        })
    }
        
    return (
        <div className={'flex item-center mt-2'}>
            {data.map((e, index) => {
                return <MapIndicator info={e} key={index} />
            })}
        </div>
    )
}